import React, {useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPerson, faPersonDress, faXmark } from '@fortawesome/free-solid-svg-icons';
import SPA_fills from './SPA_fills';

function SPA({setSPA, setBooking, setSpafills, setShortTT}) {


    const close = () =>{
        setSPA(true)
        setSpafills(false)
    }

    const exam_dur = () =>{
       setSpafills(true)
       setSPA(false)
       setShortTT('Exam Duration')
    }

    const exam_evp = () =>{
       setSpafills(true)
       setSPA(false)
       setShortTT('Event Period')
    }
 
    const exam_bnb = () =>{
        setSpafills(true)
        setSPA(false)
        setShortTT('BNB')
    }

  return (
    <div className='displays_full'>
    <div className='displays_btn'>

        <div>
            <p className='booking_alert'>Booking is Absolutley Free!!</p>
            <div className='display_btn_buttons' onClick={exam_dur}>Book For Exam Duration</div>
            <div className='display_btn_buttons' onClick={exam_evp}>Book For Event Period</div>
            <div className='display_btn_buttons' onClick={exam_bnb}>Book BnB</div>

        </div>

    </div>


  
    </div>
  )
}

export default SPA
